import axios from "axios";
import { useEffect, useState, useRef } from "react";
import beaconResultType from "../model/beaconResultType";
import Result from "../components/BeaconLogResult";
import Header from "../components/Header";
import PageSelect from "../components/PageSelect";
import BeaconModel from "../model/BeaconModel";
import ExcelJS from 'exceljs';
import "./BeaconLog.css";

const BeaconLog = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [deviceid, setDeviceId] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("100");
    const [beacon_id, setBeacon_Id] = useState<string>("");
    const [rssi_gt, setRssi_gt] = useState<string>("");
    const [rssi_lt, setRssi_lt] = useState<string>("");
    const [detected_gt, setDetcted_gt] = useState<string>("");
    const [detected_lt, setDetcted_lt] = useState<string>("");
    const [arrived_gt, setArrived_gt] = useState<string>("");
    const [arrived_lt, setArrived_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(-1);
    const [result, setResult] = useState<beaconResultType[]>([]);
    const results: beaconResultType[] = [];
    const [csvResult, setCSVResult] = useState<beaconResultType[]>([]);
    const [beaconResult, setBeaconResult] = useState<BeaconModel[]>([]);
    const beaconResults: BeaconModel[] = [];

    const [isNoCheck, setNoCheck] = useState<boolean>(false);
    const [isNamaCheck, setNameCheck] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);   // CSV全件取得
    const [isFetching, setIsFetching] = useState<boolean>(false); // 検索・ページング

    // ---- UI-only state (no data logic) ----
    const [filterOpen, setFilterOpen] = useState<boolean>(true);
    const [csvOpen, setCsvOpen] = useState<boolean>(false);
    const csvRef = useRef<HTMLDivElement>(null);

    var apiUrl: string = "";
    let beaconApiUrl = "https://api.bc-loco.jp/api/beacons"

    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/beacon_logs"
        beaconApiUrl = "https://api.bc-loco.jp/api/beacons"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/beacon_logs"
        beaconApiUrl = "http://stg.api.bc-loco.jp/api/beacons"
      }
    }

    const getBeaconLog = async(e: any, pageNo: number) => {
        e.preventDefault();
        if (per_page === "") {
          setPer_Page("100")
        }
        saveParams();
        saveApikey();
        checkLocoEnv();
        setIsFetching(true);
        try {
        await getBeacons();
        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {
              ...(deviceid ? {device_id: [deviceid]} : {}),
              ...(pageNo ? {page: pageNo} : {}),
              ...(per_page ? {per_page: per_page} : {}),
              ...(beacon_id ? {beacon_id: beacon_id} : {}),
              ...(rssi_gt ? {rssi_gt: rssi_gt} : {}),
              ...(rssi_lt ? {rssi_lt: rssi_lt} : {}),
              ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
              ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
              ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
              ...(arrived_lt ? {arrived_lt: arrived_lt.replace("T", " ")} : {}),
              ...(sort ? {sort: sort} : {})
          }
        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            return
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            return
          }
          const items = JSON.parse(JSON.stringify(res.data.payload))
            if (items.total > 100000) {
              if (pageNo === 0) {
                alert("10万件を超えるデータは表示出来ません\n10万件までのデータを表示します\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
              }
              setTotal(items.total)
              setPageNo(items.current_page)
              setLastPageNo(getLastPageNo())
            } else {
              setTotal(items.total)
              setPageNo(items.current_page)
              setLastPageNo(items.last_page)
            }

            items.data.forEach((value: beaconResultType, index: number) => {
              results.push(value)
              results[index].no = items.from;
              items.from++;
            })
            setResult(results)
        })
        .catch(err =>
          alert("エラーが発生しました。" + err)
        )
        } finally {
          setIsFetching(false);
        }
    }

    const getBeacons = async() => {
      await axios.get(beaconApiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
          ...({per_page: 1000})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        console.log(items)

        items.data.forEach((value: BeaconModel) => {
          beaconResults.push(value)
        })

        setBeaconResult(beaconResults)
        return new Promise<void>((resolve, reject) => {
          resolve()
        });
      })
      .catch(err => {
        alert("エラーが発生しました。" + err)
        return new Promise<void>((resolve, reject) => {
          reject()
        });
      })
    }

    const createCSV = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("beaconLog");
      const worksheet = workbook.getWorksheet("beaconLog");

      const columns: Partial<ExcelJS.Column>[] = [];

      if (isNoCheck) {
        columns.push({ header: "no", key: "no" })
      }
      columns.push({ header: "id", key: "id" })
      columns.push({ header: "bundle_id", key: "bundle_id" })
      columns.push({ header: "device_id", key: "device_id" })
      columns.push({ header: "beacon_id", key: "beacon_id" })
      if (isNamaCheck) {
        columns.push({ header: "name", key: "name" })
      }
      columns.push({ header: "rssi", key: "rssi" })
      columns.push({ header: "detected", key: "detected" })
      columns.push({ header: "arrived", key: "arrived" })
      columns.push({ header: "latitude", key: "latitude" })
      columns.push({ header: "longitude", key: "longitude" })
      columns.push({ header: "abs_height", key: "abs_height" })

      worksheet.columns = columns;

      setIsLoading(true);
      if (await getAllBeaconLog(e, 1) === true ) {
        csvResult.forEach((value: beaconResultType) => {
          beaconResult.forEach((beaconValue: BeaconModel) => {
            if (value.beacon_id == beaconValue.id) {
              value.name  = beaconValue.name;
            }
          })
          worksheet.addRow(value);
        });

        csvResult.length = 0;

        console.log("Row Count:" + worksheet.rowCount)
        setIsLoading(false);

        try {
          const uint8Array = await workbook.csv.writeBuffer();
          const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          setTimeout(()=> {
            a.href = url;
            a.download = "beaconlog_" + getNowDate() +  ".csv";
            a.click();
            a.remove();
          },1000)
        } catch (error) {
          alert(error);
        }
      } else {
        setIsLoading(false);
      }
    }

    const getAllBeaconLog = async(e: any, pageNo: number) => {
      let ret = true;
      e.preventDefault();
      checkLocoEnv();
      if (pageNo === 1) {
        getBeacons();
      }
      await axios.get(apiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
            ...(deviceid ? {device_id: [deviceid]} : {}),
            ...({per_page: 1000}),
            ...(pageNo ? {page: pageNo} : {}),
            ...(beacon_id ? {beacon_id: beacon_id} : {}),
            ...(rssi_gt ? {rssi_gt: rssi_gt} : {}),
            ...(rssi_lt ? {rssi_lt: rssi_lt} : {}),
            ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
            ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
            ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
            ...(arrived_lt ? {arrived_lt: arrived_lt.replace("T", " ")} : {}),
            ...(sort ? {sort: sort} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return ret = false
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 100000) {
          if (pageNo === 1) {
            let result = window.confirm("10万件を超えるデータは出力出来ません\n10万件までのデータを出力しますか？\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            if (result === false) {
              return ret = false
            }
          }
        } else {
          setLastPageNo(items.last_page)
        }

        let csvArrayCount = csvResult.length;
        items.data.forEach((value: beaconResultType, index: number) => {
          csvResult.push(value);
          csvResult[index + csvArrayCount].no = items.from;
          items.from++;
        })

        setCSVResult(csvResult);
        console.log("lastPageNo:" + lastPageNo)

        if (items.last_page > 100) {
          if (items.current_page != 100) {
            await getAllBeaconLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        } else {
          if (items.current_page != items.last_page) {
            await getAllBeaconLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        }
      })
      .catch(err =>
        alert("エラーが発生しました。" + err)
      )

      return ret
  }

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_gt(value);
  }
  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_lt(value);
  }
  const changeArrivedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setArrived_gt(value);
  }
  const changeArrivedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setArrived_lt(value);
  }
  const changePerPage = (value: string) => { setPer_Page(value) }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    return y + m + d;
  }

  const getLastPageNo = () => {
    if (per_page === "") { return 100000 / 100 }
    else { return 100000 / Number(per_page) }
  }

  type beaconParamsType = {
    apikey?: string, deviceid?: string, perpage?: string, beaconid?: string,
    rssigt?: string, rssilt?: string, detectedgt?: string, detectedlt?: string,
    arrivedgt?: string, arrivedlt?: string, sort?: string
  }

  const saveParams = () => {
    let params: beaconParamsType = {};
    params.deviceid = deviceid ? deviceid : "";
    params.perpage = per_page ? per_page : "";
    params.beaconid = beacon_id ? beacon_id : "";
    params.rssigt = rssi_gt ? rssi_gt : "";
    params.rssilt = rssi_lt ? rssi_lt : "";
    params.detectedgt = detected_gt ? detected_gt : "";
    params.detectedlt = detected_lt ? detected_lt : "";
    params.arrivedgt = arrived_gt ? arrived_gt : "";
    params.arrivedlt = arrived_lt ? arrived_lt : "";
    params.sort = sort ? sort : "";
    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoBeaconParams", json)
  }

  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoBeaconParams")
    if (paramsJson != null) {
      const params:beaconParamsType = JSON.parse(paramsJson as string)
      setDeviceId(params.deviceid ? params.deviceid : "");
      setPer_Page(params.perpage ? params.perpage : "")
      setBeacon_Id(params.beaconid ? params.beaconid : "");
      setRssi_gt(params.rssigt ? params.rssigt : "");
      setRssi_lt(params.rssilt ? params.rssilt : "");
      setDetcted_gt(params.detectedgt ? params.detectedgt : "");
      setDetcted_lt(params.detectedlt ? params.detectedlt : "");
      setArrived_gt(params.arrivedgt ? params.arrivedgt : "");
      setArrived_lt(params.arrivedlt ? params.arrivedlt : "");
      setSort(params.sort ? params.sort : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) { setApikey(locoApikey ? locoApikey : ""); }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
        const secret = JSON.parse(secretJson as string)
        const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
        const option1 = document.createElement("option");
        option1.value = "";
        option1.textContent = "APIKeyを選択して下さい";
        selectApikey?.appendChild(option1)
        secret.forEach((element: { apikey: string; name: string | null; }) => {
            const option1 = document.createElement("option");
            option1.value = element.apikey;
            option1.textContent = element.name;
            selectApikey?.appendChild(option1)
        })
    }
  }

  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) { setSelectApikey() }
    loadParams();
    loadApikey();
  },[])

  // close CSV popover on outside click
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      if (csvRef.current && !csvRef.current.contains(ev.target as Node)) setCsvOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // ---- active filter chips (UI only) ----
  type Chip = { key: string; label: string; value: string; clear: () => void };
  const activeChips: Chip[] = [
    apiKey ? { key: "apiKey", label: "ApiKey", value: "設定済み", clear: () => setApikey("") } : null,
    deviceid ? { key: "device", label: "Device", value: deviceid, clear: () => setDeviceId("") } : null,
    beacon_id ? { key: "beacon", label: "Beacon", value: beacon_id, clear: () => setBeacon_Id("") } : null,
    rssi_gt ? { key: "rgt", label: "RSSI ≥", value: rssi_gt, clear: () => setRssi_gt("") } : null,
    rssi_lt ? { key: "rlt", label: "RSSI ≤", value: rssi_lt, clear: () => setRssi_lt("") } : null,
    detected_gt ? { key: "dgt", label: "Detected ≥", value: detected_gt, clear: () => setDetcted_gt("") } : null,
    detected_lt ? { key: "dlt", label: "Detected ≤", value: detected_lt, clear: () => setDetcted_lt("") } : null,
    arrived_gt ? { key: "agt", label: "Arrived ≥", value: arrived_gt, clear: () => setArrived_gt("") } : null,
    arrived_lt ? { key: "alt", label: "Arrived ≤", value: arrived_lt, clear: () => setArrived_lt("") } : null,
    sort ? { key: "sort", label: "Sort", value: sort.toUpperCase(), clear: () => setSort("") } : null,
    (per_page && per_page !== "100") ? { key: "pp", label: "Per_Page", value: per_page, clear: () => setPer_Page("100") } : null,
  ].filter(Boolean) as Chip[];

  const resetFilters = () => {
    setDeviceId(""); setBeacon_Id(""); setRssi_gt(""); setRssi_lt("");
    setDetcted_gt(""); setDetcted_lt(""); setArrived_gt(""); setArrived_lt("");
    setSort(""); setPer_Page("100");
  };

  return (
    <div className="bl-page">
      <Header current_page="Beacon"/>

      <div className="bl-shell">
        {/* ---------- Sidebar: filters ---------- */}
        <aside className={"bl-aside" + (filterOpen ? "" : " collapsed")}>
          <div className="bl-aside-head">
            <span className="bl-aside-title">
              <Ico name="filter"/> 検索条件
            </span>
            <button type="button" className="bl-btn ghost sm icon" title={filterOpen ? "閉じる" : "開く"}
              onClick={() => setFilterOpen(o => !o)}>
              <Ico name={filterOpen ? "chevronLeft" : "chevronRight"}/>
            </button>
          </div>

          <form id="bl-filter-form" className="bl-aside-body" autoComplete="on" onSubmit={(e) => getBeaconLog(e, 0)}>
            <div>
              <div className="bl-group-label">接続先</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">APIKEY</label>
                  <select id="apikey" className="bl-select" value={apiKey} onChange={(e) => setApikey(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>PER_PAGE</span>
                    <span className="bl-field-hint">既定100 / 最大1000</span>
                  </label>
                  <input className="bl-input" type="text" name="per_page" value={per_page}
                    placeholder="1ページ辺りの最大件数" onChange={(e) => changePerPage(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">識別子</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">DEVICE_ID</label>
                  <input className="bl-input bl-mono" type="text" name="deviceId" value={deviceid}
                    placeholder="Device_Idを入力" onChange={(e) => setDeviceId(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">BEACON_ID</label>
                  <input className="bl-input bl-mono" type="text" name="beacon_id" value={beacon_id}
                    placeholder="Beacon_Idを入力" onChange={(e) => setBeacon_Id(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">RSSI 範囲</div>
              <div className="bl-grid-2">
                <div>
                  <label className="bl-field-label">以上</label>
                  <input className="bl-input" type="text" name="rssi_gt" value={rssi_gt}
                    placeholder="例: -80" onChange={(e) => setRssi_gt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以下</label>
                  <input className="bl-input" type="text" name="rssi_lt" value={rssi_lt}
                    placeholder="例: -30" onChange={(e) => setRssi_lt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Detected（ビーコン発見時刻）</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">以降</label>
                  <input className="bl-input" type="datetime-local" step="1" autoComplete="on" name="detected_gt"
                    value={detected_gt} onChange={(e) => changeDetectedGt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以前</label>
                  <input className="bl-input" type="datetime-local" step="1" name="detected_lt"
                    value={detected_lt} onChange={(e) => changeDetectedLt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Arrived（サーバー到達時刻）</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">以降</label>
                  <input className="bl-input" type="datetime-local" step="1" name="arrived_gt"
                    value={arrived_gt} onChange={(e) => changeArrivedGt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以前</label>
                  <input className="bl-input" type="datetime-local" step="1" name="arrived_lt"
                    value={arrived_lt} onChange={(e) => changeArrivedLt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">並び順</div>
              <select className="bl-select" value={sort} onChange={e => setSort(e.target.value)}>
                <option value="">ASC / DESC を指定</option>
                <option value="asc">ASC（古い順）</option>
                <option value="desc">DESC（新着順）</option>
              </select>
            </div>

            <button type="button" className="bl-btn block" onClick={resetFilters}>Reset</button>
          </form>
        </aside>

        {/* ---------- Main ---------- */}
        <main className="bl-main">
          <div className="bl-section-head">
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {!filterOpen && (
                <button type="button" className="bl-btn ghost sm icon" title="検索条件を開く" onClick={() => setFilterOpen(true)}>
                  <Ico name="filter"/>
                </button>
              )}
              <h2>BeaconLog</h2>
              {total >= 0 && <span className="bl-badge">{total.toLocaleString()} records</span>}
            </div>

            <div className="bl-toolbar">
              <button type="submit" form="bl-filter-form" className="bl-btn accent" disabled={isFetching || isLoading}>
                {isFetching
                  ? <><span className="bl-spin-sm" /> 検索中…</>
                  : <><Ico name="search"/> 検索</>}
              </button>
              <div className="bl-pop-wrap" ref={csvRef}>
                <div className="bl-split">
                  <button type="button" className="bl-btn secondary" onClick={(e) => createCSV(e)} disabled={isFetching || isLoading}>
                    {isLoading
                      ? <><span className="bl-spin-sm" style={{ borderColor: "rgba(0,0,0,.15)", borderTopColor: "var(--bl-accent)" }} /> 出力中…</>
                      : <><Ico name="download"/> CSV出力</>}
                  </button>
                  <button type="button" className="bl-btn secondary" title="CSV出力オプション" onClick={() => setCsvOpen(o => !o)} disabled={isFetching || isLoading}>
                    <Ico name="chevronDown"/>
                  </button>
                </div>
                {csvOpen && (
                  <div className="bl-pop" style={{ width: 220 }}>
                    <div className="bl-pop-title">CSV出力に含める項目</div>
                    <label className="bl-pop-item">
                      <input type="checkbox" checked={isNoCheck} onChange={() => setNoCheck(p => !p)} /> no
                    </label>
                    <label className="bl-pop-item">
                      <input type="checkbox" checked={isNamaCheck} onChange={() => setNameCheck(p => !p)} /> name
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Active filters strip */}
          <div className="bl-chips">
            <span className="bl-chips-label">条件</span>
            {activeChips.length === 0 && <span className="bl-chips-empty">条件は未設定です</span>}
            {activeChips.map(c => (
              <span key={c.key} className="bl-chip">
                <span className="k">{c.label}</span>
                <span className="v bl-mono">{c.value}</span>
                <button type="button" className="x" title="削除" onClick={c.clear}><Ico name="close" size={10}/></button>
              </span>
            ))}
          </div>

          {/* Results */}
          <div className="bl-results-region">
            {(beaconResult.length >= 0 && total > 0) ? (
              <>
                <Result beaconlogs={result} beaconData={beaconResult} />
                <div className="bl-footer">
                  <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getBeaconLog} />
                </div>
              </>
            ) : (
              <div className="bl-empty">
                <Ico name="database" size={28} />
                <span className="big">{total === 0 ? "該当するログがありません" : "BeaconLogを検索"}</span>
                <span>{total === 0 ? "条件を変更して再検索してください" : "左の条件を指定して「検索」を押してください"}</span>
              </div>
            )}

            {(isFetching || isLoading) && (
              <div className="bl-overlay">
                <span className="bl-spin-lg" />
                <span>{isLoading ? "CSV出力中… しばらくお待ちください" : "読み込み中…"}</span>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  )
}

/* inline icon set — no extra deps */
const Ico = ({ name, size = 14 }: { name: string; size?: number }) => {
  const paths: Record<string, JSX.Element> = {
    filter: <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />,
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /><path d="M12 15V3" /></>,
    close: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
    chevronLeft: <path d="m15 18-6-6 6-6" />,
    chevronRight: <path d="m9 18 6-6-6-6" />,
    chevronDown: <path d="m6 9 6 6 6-6" />,
    play: <path d="m7 4 12 8-12 8V4Z" />,
    database: <><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14a9 3 0 0 0 18 0V5" /><path d="M3 12a9 3 0 0 0 18 0" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {paths[name]}
    </svg>
  );
};

export default BeaconLog